import { FC, useEffect, useState } from 'react'

import { useRouter } from 'next/navigation'

import { StandardButton } from 'src/components/atoms'

import { useAuth } from 'src/hooks'
import { Routes } from 'src/routes'

type Props = {
  className?: string
}

export const Logout: FC<Props> = ({ className }) => {
  const [isLoading, setIsLoading] = useState(false)

  const router = useRouter()
  const { logout } = useAuth()

  const handleOnLogout = async () => {
    setIsLoading(true)

    await logout()

    router.replace(Routes.SignIn.path)
    setIsLoading(false)
  }

  useEffect(() => {
    return () => setIsLoading(false)
  }, [])

  return (
    <div className={className}>
      <StandardButton
        text="ログアウト"
        prependIconPath="log-out/soft/line"
        buttonType="secondary"
        isLoading={isLoading}
        onClick={handleOnLogout}
      />
    </div>
  )
}
